import { storage } from "@/utils/storage"; //removeStorage
import { getToken, setToken, removeToken } from "@/utils/auth"; //
import { encrypt } from "@/utils/crypto";
import fetch from "@/utils/request";
const user = {
  state: {
    token: getToken(),
    id: storage({ key: "user_id" }) || "",
    name: storage({ key: "user_name" }) || "",
    avatar: storage({ key: "user_avatar" }) || "",
    profile: storage({ key: "user_profile" }) || {},
    msgNumber: storage({ key: "user_msg_number" }) || {},
    isLogin: storage({ key: "user_is_login" }) || false, // 是否登录,
    isAuth: storage({ key: "user_is_auth" }) || false, // 用户邮箱认证,
    searchHistory: storage({ key: "user_search_history" }) || [],
    loginIdent: "", // 这个字段不存储 是否拥有登录信息 值为user_id
  },

  mutations: {
    SET_ID: (state, id) => {
      state.id = id;
      state.loginIdent = id;
      storage({ key: "user_id", value: id });
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      storage({ key: "token", value: token });
      token && setToken(token);
      !token && removeToken();
    },
    SET_NAME: (state, name) => {
      state.name = name;
      storage({ key: "user_name", value: name });
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
      storage({ key: "user_avatar", value: avatar });
    },
    SET_PROFILE: (state, profile) => {
      state.profile = profile;
      storage({ key: "user_profile", value: profile });
    },
    SET_MSG_NUMBER: (state, msgNumber) => {
      state.msgNumber = msgNumber;
      storage({ key: "user_msg_number", value: msgNumber });
    },
    SET_IS_LOGIN: (state, isLogin) => {
      state.isLogin = isLogin;
      storage({ key: "user_is_login", value: isLogin });
    },
    SET_IS_AUTH: (state, isAuth) => {
      state.isAuth = isAuth;
      storage({ key: "user_is_auth", value: isAuth });
    },
    SET_SEARCH_HISTORY: (state, searchHistory) => {
      state.searchHistory = searchHistory;
      storage({ key: "user_search_history", value: searchHistory });
    },
  },
  actions: {
    /* 短信登录 */
    async smsLogin({ commit }, payload = {}) {
      try {
        const { user_mobile, verify_code } = payload.params || {};
        const params = { user_mobile, verify_code };
        const resp = await fetch({
          url: "/Sys/loginRegBySms",
          method: "POST",
          data: params,
          eTarget: payload.eTarget,
        });
        const { state, data } = resp || {};
        const { token } = data || {};
        commit("SET_TOKEN", token);
        return { flag: state === 0, ...resp };
      } catch (error) {
        return { flag: false, ...error };
      }
    },
    /* 密码登录 */
    async pwdLogin({ commit }, payload = {}) {
      try {
        const { user_mobile, user_pwd } = payload.params || {};
        const params = { user_mobile, user_pwd: encrypt(user_pwd) };
        const resp = await fetch({
          url: "/Sys/login",
          method: "POST",
          data: params,
          eTarget: payload.eTarget,
        });
        const { state, data } = resp || {};
        const { token } = data || {};
        commit("SET_TOKEN", token);
        return { flag: state === 0, ...resp };
      } catch (error) {
        return { flag: false, ...error };
      }
    },
    // 退出系统
    logout({ commit }, payload = {}) {
      commit("SET_ID", "");
      commit("SET_TOKEN", "");
      commit("SET_AVATAR", "");
      commit("SET_PROFILE", {});
      commit("SET_IS_LOGIN", false);
      commit("SET_IS_AUTH", 0);
      typeof payload.cb === "function" && payload.cb();
    },
    // 获取用户信息
    async fetchLoginUserInfo({ commit }, payload = {}) {
      try {
        const resp = await fetch({
          url: "/Sys/getLoginSysUser",
          method: "GET",
          eTarget: payload.eTarget,
        });
        const { state, data: profile = {} } = resp || {};
        const { user_name, user_avatar_url, id, is_authentication } =
          profile || {};
        commit("SET_ID", id);
        commit("SET_NAME", user_name);
        commit("SET_AVATAR", user_avatar_url);
        commit("SET_PROFILE", profile);
        commit("SET_IS_LOGIN", true);
        commit("SET_IS_AUTH", is_authentication);
        return { flag: state === 0, ...resp };
      } catch (error) {
        return { flag: false, ...error };
      }
    },

    /* 登录过期处理 */
    loginExpiration({ dispatch }, payload = {}) {
      dispatch("logout");
      typeof payload.cb === "function" && payload.cb();
    },
    /* 消息相关 */
    async fetchMsgNumber({ commit }, payload = {}) {
      try {
        const { isLogin = false } = this.getters || {};
        if (!isLogin) return;
        const resp = await fetch({
          // url: "/Message/getUserSysInteractionNotReadCount",
          url: "/Message/getUserAllNotReadConversationMessageCount",
          method: "GET",
          unShowErrorTip: true,
        });
        const { state, data } = resp;
        if (state !== 0) return;
        const result = data || {};
        const { interaction_count = 0, system_count = 0 } = result;
        const bell_msg = system_count + interaction_count;
        const msgNumber = {
          ...result,
          bell_msg: bell_msg || 0,
          chat_msg: result.msg_count || 0,
          system_msg: system_count || 0,
          interact_msg: interaction_count || 0,
        };
        commit("SET_MSG_NUMBER", msgNumber);
        typeof payload.cb == "function" && payload.cb(data);
      } catch (_) {
        /* eslint-disable-next-line */
      }
    },
    /* 获取用户搜索历史 */
    async fetchSearchHistory({ commit }) {
      try {
        const { isLogin = false } = this.getters || {};
        const params = {
          page_num: 1,
          page_size: 9999,
          cond_list: [],
          type: "PC",
        };
        if (!isLogin) return;
        const resp = await fetch({
          url: "/Index/getUserSearchList",
          method: "POST",
          data: params,
          unShowErrorTip: true,
        });
        const { state, data } = resp;
        const { row_list = [] } = data;
        if (state !== 0) return;
        commit("SET_SEARCH_HISTORY", row_list);
      } catch (error) {
        console.log("__ >>::", error);
      }
    },
  },
};

export default user;
